export type Stage = 'dev' | 'tst' | 'acc' | 'prd';

export interface Environment {
  production: boolean;
  stage: Stage;
}

export const createEnvironment = (overrides: Partial<Environment>): Environment => ({
  production: false,
  stage: 'dev',
  ...overrides,
});
